import { useEffect, useState } from "react";
import { X, AlarmClock, ArrowRight } from "lucide-react";
import { PriorityBadge } from "./ui-bits";

function overdueText(dueAt) {
  if (!dueAt) return "";
  const secs = Math.max(0, (Date.now() - new Date(dueAt).getTime()) / 1000);
  const d = Math.floor(secs / 86400);
  const h = Math.floor((secs % 86400) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  if (d) return `${d}d ${h}h overdue`;
  if (h) return `${h}h ${m}m overdue`;
  return `${m}m overdue`;
}

export default function DeadlineToast({ evt, onView, onDismiss }) {
  const isDeadline = evt.ntype === "deadline";
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!isDeadline) return undefined;
    const t = setInterval(() => setTick((x) => x + 1), 30000);
    return () => clearInterval(t);
  }, [isDeadline]);

  const task = evt.task;
  const dueLabel = task.due_date + (task.due_time ? ` · ${task.due_time}` : "");

  return (
    <div data-testid={`deadline-toast-${task.id}`} className="w-[340px] max-w-[calc(100vw-2rem)] bg-background border border-border border-l-4 border-l-[#E31E24] rounded-lg shadow-lg p-3">
      <div className="flex items-start gap-2.5">
        <span className="h-8 w-8 rounded-md bg-[#E31E24]/10 text-[#E31E24] flex items-center justify-center shrink-0">
          <AlarmClock size={16} />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold font-heading">{isDeadline ? "Deadline reached" : "Deadline reminder"}</p>
          <p className="text-sm font-medium truncate" data-testid="deadline-toast-title">{task.title}</p>
          <p className="text-xs text-muted-foreground truncate">{evt.project_name}</p>
          <div className="flex items-center gap-2 mt-1.5 flex-wrap">
            <PriorityBadge priority={task.priority} />
            <span className="text-xs text-muted-foreground" data-testid="deadline-toast-due">Due {dueLabel}</span>
          </div>
          {isDeadline
            ? <p className="text-xs font-semibold text-[#E31E24] mt-1" data-testid="deadline-overdue-duration">{overdueText(task.due_at)}</p>
            : <p className="text-xs text-muted-foreground mt-1">{evt.minutes >= 1440 ? "Due in 24 hours" : "Due in 1 hour"}</p>}
        </div>
        <button data-testid="deadline-toast-dismiss" onClick={onDismiss} className="text-muted-foreground hover:text-foreground transition-colors shrink-0">
          <X size={14} />
        </button>
      </div>
      <button data-testid="deadline-toast-view" onClick={onView}
        className="mt-2.5 w-full h-8 flex items-center justify-center gap-1.5 text-sm font-medium rounded-md bg-[#E31E24] hover:bg-[#C81A1F] text-white transition-colors">
        View Task <ArrowRight size={14} />
      </button>
    </div>
  );
}
